export const SupportFormat = {
    UserEmail:"",
    Application:"",
    IssueDescription:"",
    file:""
}
